export default __webpack_public_path__ + "static/media/Picture_072.9fbe3a9d.jpg";